import type { SVGProps } from 'react';
const DawnFlagSV = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-SV_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-SV_svg__a)">
      <path fill="#1B57C4" d="M0 5.333h22V0H0zM0 16h22v-5.333H0z" />
      <path
        fill="url(#dawn-flag-SV_svg__b)"
        d="M9.742 6.293A2.14 2.14 0 0 0 8.904 8c0 1.178.938 2.133 2.095 2.133S13.096 9.178 13.096 8c0-.698-.33-1.318-.838-1.707l-.734 2.24h-1.047z"
      />
      <path fill="#F9C92E" d="m11 5.867.524 2.666h-1.047z" />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-SV_svg__b"
        x1={8.904}
        x2={8.904}
        y1={6.293}
        y2={10.133}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3C7839" />
        <stop offset={1} stopColor="#31642E" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagSV;
